module.exports = __webpack_public_path__ + "static/11-be790cffbc7a2006cf71fa32d4ea64f6.jpg";